import Phaser from "phaser";

/**
 * Renders sprays placed on the ground as stickers, visible to every player in the
 * instance. Unlike blood splatters (client-local, time-based expiry) stickers are
 * server-broadcast and persist for the whole match — cleared only via removeAll()
 * on match end (see main-scene.ts's shutdown() + the "match-sticker-cleanup" event).
 */
export class StickerManager {
  private scene: Phaser.Scene;
  private stickers: Map<string, Phaser.GameObjects.Sprite> = new Map();

  constructor(scene: Phaser.Scene) {
    this.scene = scene;
  }

  place(stickerId: string, textureKey: string, x: number, y: number): void {
    if (this.stickers.has(stickerId)) return;
    if (!this.scene.textures.exists(textureKey)) return;

    const sprite = this.scene.add.sprite(x, y, textureKey);
    sprite.setOrigin(0.5);
    sprite.setDepth(1);

    const cameras = this.scene.cameras.cameras;
    cameras.forEach((camera: Phaser.Cameras.Scene2D.Camera) => {
      if (camera !== this.scene.cameras.main) {
        camera.ignore(sprite);
      }
    });

    sprite.setScale(0);
    this.scene.tweens.add({
      targets: sprite,
      scale: 1,
      duration: 250,
      ease: "Back.easeOut",
    });

    this.stickers.set(stickerId, sprite);
  }

  removeAll(): void {
    this.stickers.forEach((sprite) => sprite.destroy());
    this.stickers.clear();
  }
}
